import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(150%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const Bar = styled.div`
  position: fixed;
  bottom: 24px;
  left: 16px;
  right: 16px;
  background-color: var(--secondary);
  color: white;
  padding: 16px;
  border-radius: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 418px;
  margin: 0 auto;
  box-shadow: 0 20px 50px rgba(211, 47, 47, 0.3);
  z-index: 40;
  animation: ${slideUp} 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.3s;

  @media (min-width: 1024px) {
    max-width: 680px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
`;

const CartInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 8px;
`;

const IconWrapper = styled.div`
  position: relative;
  font-size: 24px;
`;

const Badge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #facc15;
  color: var(--secondary);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
`;

const TextInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.p`
  font-size: 10px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  line-height: 1;
  margin: 0 0 2px 0;
`;

const Value = styled.p`
  font-size: 20px;
  font-weight: 900;
  margin: 0;
`;

const FinishButton = styled.button`
  background-color: white;
  color: var(--secondary);
  padding: 12px 24px;
  border-radius: 1rem;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 14px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

interface CartBarProps {
    total: number;
    count: number;
    onOpen: () => void;
}

export const CartBar: React.FC<CartBarProps> = ({ total, count, onOpen }) => {
    return (
        <Bar>
            <CartInfo>
                <IconWrapper>
                    <i className="fas fa-shopping-basket"></i>
                    <Badge>{count}</Badge>
                </IconWrapper>
                <TextInfo>
                    <Label>Subtotal</Label>
                    <Value>{total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Value>
                </TextInfo>
            </CartInfo>
            <FinishButton onClick={onOpen}>Finalizar</FinishButton>
        </Bar>
    );
};
